__turbopack_context__.v({
  "ad1": "HomePageStories-module__VyXcdW__ad1",
  "ad2": "HomePageStories-module__VyXcdW__ad2",
  "ads": "HomePageStories-module__VyXcdW__ads",
  "ads_diamensions": "HomePageStories-module__VyXcdW__ads_diamensions",
  "arrow": "HomePageStories-module__VyXcdW__arrow",
  "authorName": "HomePageStories-module__VyXcdW__authorName",
  "author_by": "HomePageStories-module__VyXcdW__author_by",
  "category": "HomePageStories-module__VyXcdW__category",
  "checkedStory": "HomePageStories-module__VyXcdW__checkedStory",
  "post-title": "HomePageStories-module__VyXcdW__post-title",
  "post__info": "HomePageStories-module__VyXcdW__post__info",
  "posthomepage__featuredArticle": "HomePageStories-module__VyXcdW__posthomepage__featuredArticle",
  "posthomepage__featuredArticles": "HomePageStories-module__VyXcdW__posthomepage__featuredArticles",
  "posthomepage__featuredArticles__section": "HomePageStories-module__VyXcdW__posthomepage__featuredArticles__section",
  "posthomepage__recentStories": "HomePageStories-module__VyXcdW__posthomepage__recentStories",
  "posthomepage__recentStories__section": "HomePageStories-module__VyXcdW__posthomepage__recentStories__section",
  "posthomepage__recentStory": "HomePageStories-module__VyXcdW__posthomepage__recentStory",
  "posthomepage__stories": "HomePageStories-module__VyXcdW__posthomepage__stories",
  "posthomepage__top__stories": "HomePageStories-module__VyXcdW__posthomepage__top__stories",
  "posthomepage__top__story": "HomePageStories-module__VyXcdW__posthomepage__top__story",
  "posthomepage__trendingStories": "HomePageStories-module__VyXcdW__posthomepage__trendingStories",
  "posthomepage__trendingStories__section": "HomePageStories-module__VyXcdW__posthomepage__trendingStories__section",
  "posthomepage__trendingStory": "HomePageStories-module__VyXcdW__posthomepage__trendingStory",
  "promoted": "HomePageStories-module__VyXcdW__promoted",
  "recentStories": "HomePageStories-module__VyXcdW__recentStories",
  "right": "HomePageStories-module__VyXcdW__right",
  "sub-title": "HomePageStories-module__VyXcdW__sub-title",
  "topStories": "HomePageStories-module__VyXcdW__topStories",
  "trendingStories": "HomePageStories-module__VyXcdW__trendingStories",
  "trendingstories__readnow__button": "HomePageStories-module__VyXcdW__trendingstories__readnow__button",
  "trendingstories__readnow__text": "HomePageStories-module__VyXcdW__trendingstories__readnow__text",
});
